
/**
 * HTMLElement check type-guard
 */

const isHTMLElement = (thing: unknown): thing is HTMLElement => thing instanceof HTMLElement;

/**
 * Create the filter function
 */

const createFilter = (button: HTMLElement) => {
	const targetSelector = button.getAttribute('data-filter-target');
	const condition = button.getAttribute('data-filter-condition');
	const headingSelector = button.getAttribute('data-filter-heading-target');
	const headingText = button.getAttribute('data-filter-heading-text');
	const headingElement = headingSelector ? document.querySelector<HTMLElement>(headingSelector) : null;

	if (!targetSelector || !condition) return;

	const setHeading = () => {
		if (!headingElement || !headingText) return;
		headingElement.textContent = headingText;
	};

	const targets = document.querySelectorAll<HTMLElement>(targetSelector);

	const applyFilter = () => {
		targets.forEach((target) => {
			Array.from(target.children)
				.filter(isHTMLElement)
				.forEach((child) => {
					if (child.matches(condition)) {
						child.style.removeProperty('display');
					} else {
						child.style.display = 'none';
					}
				});
		});
	};

	const updatePressedState = () => {
		Array.from(button.parentElement?.children || [])
			.filter(isHTMLElement)
			.forEach((sibling) => {
				if (sibling.matches('[data-filter-toggle-button]')) return;

				sibling.setAttribute(
					'aria-pressed',
					sibling === button ? 'true' : 'false',
				);
			});
	};

	button.addEventListener('click', () => {
		setHeading();
		applyFilter();
		updatePressedState();
	});

	if (button.getAttribute('aria-pressed') == 'true') {
		applyFilter();
	}
};

document
	.querySelectorAll<HTMLElement>('[data-filter-target]')
	.forEach(createFilter);

/**
 * Handle toggle element click
 */

const createToggleButton = (button: HTMLElement) => {
	button.addEventListener('click', () => {
		const inactiveButton = button.parentElement?.querySelector(
			'[aria-pressed="false"]:not([data-filter-toggle-button])',
		);

		if (!(inactiveButton instanceof HTMLButtonElement)) return;

		inactiveButton.click();
	});
};

document
	.querySelectorAll<HTMLElement>('[data-filter-toggle-button]')
	.forEach(createToggleButton);
